<template>
  <div :class="stacked ? 'chat-widget-actions-stacked' : 'chat-widget-actions'">
    <button
      v-for="btn in buttons"
      :key="btn.action"
      class="btn btn-sm"
      :class="buttonClass(btn)"
      :title="btn.tooltip || ''"
      :disabled="disabled"
      @click="$emit('action', btn.action)"
    >
      <i
        v-if="btn.iconOnly && btn.iconClass"
        :class="btn.iconClass"
      />
      <template v-else>
        <i
          v-if="btn.iconClass"
          class="mr-1"
          :class="btn.iconClass"
        />
        {{ btn.label }}
      </template>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AIChatWidgetActionButtons',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    selectedAction: {
      type: String,
      default: '',
    },
  },
  methods: {
    buttonClass(btn) {
      const classes = [];
      if (btn.iconOnly) classes.push('btn-icon-only');
      if (btn.variant === 'plain') {
        classes.push('btn-plain');
        return classes;
      }
      if (this.selectedAction) {
        classes.push(btn.action === this.selectedAction ? 'btn-primary' : 'btn-outline-secondary');
      } else {
        classes.push('btn-' + (btn.variant || 'primary'));
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-widget-actions-stacked {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;

  .btn {
    font-size: 13px;
    padding: 4px 12px;
    border-radius: 6px;
    width: 100%;
    text-align: left;
  }

  .btn-primary {
    // Match the darker Creative Studio message green for contrast (POR-13596)
    background-color: #379C75;
    border-color: #379C75;

    &:hover:not(:disabled) {
      background-color: #2E8D68;
      border-color: #2E8D68;
    }
  }

  .btn-outline-secondary {
    color: #999;
    border-color: #ddd;
    background-color: transparent;
  }
}

.chat-widget-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  .btn {
    font-size: 13px;
    padding: 4px 12px;
    border-radius: 6px;
    white-space: nowrap;
  }

  .btn-primary {
    // Match the darker Creative Studio message green for contrast (POR-13596)
    background-color: #379C75;
    border-color: #379C75;

    &:hover:not(:disabled) {
      background-color: #2E8D68;
      border-color: #2E8D68;
    }
  }

  .btn-light {
    border-color: #e5e7eb;
  }

  .btn-outline-secondary {
    color: #999;
    border-color: #ddd;
    background-color: transparent;
  }

  .btn-plain {
    background: transparent;
    border: none;
    color: #4b5563;
    padding: 4px 8px;

    &:hover:not(:disabled) {
      color: #111827;
      background: rgba(0, 0, 0, 0.04);
    }
  }

  .btn-icon-only {
    background: transparent;
    border: none;
    color: #4b5563;
    padding: 4px 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 1;

    &:hover:not(:disabled) {
      color: #111827;
      background: rgba(0, 0, 0, 0.04);
    }
  }
}
</style>
